<script lang="ts">import RemoteIcon from "./remote-icon.svelte";
export let size = 20;
</script>

<RemoteIcon icon="SupportChatHelpIcon" {size} color="currentColor" />
